import { Injectable } from '@angular/core';
import { FieldAgentClient, WebTrackUser, UserOption, LabelsRequest, LabelTemplateQty, LabelTemplateQtyKind, LabelTemplateKind,
  BisTrackSettings, LabelsRequestResult, LabelsRequestPrintingMode } from 'ep-bt-field-agent-proxy';
import { BistrackConfig, PageNames } from 'ep-bt-controls';
import { EpbtFieldAgentService } from '../services/epbt-field-agent.service';


@Injectable({
  providedIn: 'root'
})
export class EpbtFaLabelsService {

  public labelRequestFormFlag: boolean;

  public bisTrackSettings: BisTrackSettings;

  public webTrackUser: WebTrackUser;

  public currency: any;

  public labelsRequest: LabelsRequest;

  public wizardStep = 0;

  public fromDashboard: boolean;

  public productsCount = 0;

  public successMessage = '';

  public isMoreProducts = false;

  public fromPageToLabels: string = PageNames.ProductSearch;

  constructor(private client: FieldAgentClient, private config: BistrackConfig,
    private faService: EpbtFieldAgentService) {
    this.faService.getBisTrackSetting((bisTrackSettings: any) => {
      this.bisTrackSettings = bisTrackSettings;
      this.currency = this.bisTrackSettings.baseCurrency.symbol;
    });
    this.faService.getWebTrackUser((webTrackUser: any) => {
      this.webTrackUser = webTrackUser;
    });
  }

  getUserOptions(webTrackUserId: number,
    subscribe: (userOptions: UserOption[]) => void) {

    this.client.getUserOptions(webTrackUserId).subscribe(userOptions => {
      subscribe(userOptions);
    });
  }

  setUserOptions(userOption: UserOption,
    subscribe: (result: boolean) => void) {

    this.client.setUserOptions(userOption).subscribe(result => {
      subscribe(result);
    });
  }

  getAllLabelTemplates(subscribe: (labelTemplatesQty: LabelTemplateQty[]) => void) {

    this.client.getLabelTemplates().subscribe(labelTemplates => {
      const labelTemplatesQty: LabelTemplateQty[] = [];
      if (labelTemplates && labelTemplates.length > 0) {
        labelTemplates.forEach(template => {
          const templateQty = new LabelTemplateQty();
          templateQty.id = template.id;
          templateQty.name = template.name;
          templateQty.defaultQuantity = template.defaultQuantity;
          templateQty.branchPrinter = template.branchPrinter;
          templateQty.branchPrinterName = template.branchPrinterName;
          templateQty.requestedQuantity = template.defaultQuantity;
          switch (template.kind) {
            case LabelTemplateKind.Bin:
              templateQty.kind = LabelTemplateQtyKind.Bin;
              break;
            case LabelTemplateKind.BinLocation:
              templateQty.kind = LabelTemplateQtyKind.BinLocation;
              break;
            case LabelTemplateKind.Item:
              templateQty.kind = LabelTemplateQtyKind.Item;
              break;
            case LabelTemplateKind.SpecifiedQuantity:
              templateQty.kind = LabelTemplateQtyKind.SpecifiedQuantity;
              break;
            case LabelTemplateKind.Undefined:
              templateQty.kind = LabelTemplateQtyKind.Undefined;
              break;
            default:
              break;
          }
          labelTemplatesQty.push(templateQty);
        });
      }
      subscribe(labelTemplatesQty);
    });
  }

  printLabels(userID: number, labelsRequest: LabelsRequest,
    subscribe: (labelsRequestResult: LabelsRequestResult[]) => void) {

    this.client.printLabels(userID, labelsRequest).subscribe(labelsRequestResult => {
      subscribe(labelsRequestResult);
    });
  }

  addProductsToLabelsRequest(product) {
    if (this.labelsRequest.products) {
      const index = this.labelsRequest.products.findIndex(p => p.productId == product.productId);
      if (index == -1) {
        // Add the selected product to the LabelsRequest.
        // adding below line because the dateTimeCreated property is updating to some unknown value in proxy while doing JSON.Stringfy(LabelsRequest);
        // because of which API is throwing error
        product.dateTimeCreated = new Date();
        product.dateTimeLastModified = new Date();
        this.labelsRequest.products.push(product);
        this.productsCount = this.labelsRequest.products.length;
        // and immediately submit label request to the queue
        // if (this.labelsRequest.printingMode == LabelsRequestPrintingMode.OnDemand) {

        //   // we sending LabelsRequest with single product here
        //   let labelsRequest: LabelsRequest = new LabelsRequest();
        //   labelsRequest.products = [];
        //   // same list of templates as in Session
        //   // labelsRequest.templates = this.labelsRequest.templates;
        //   labelsRequest.templates = this.labelsRequest.templates.filter(t => t.requestedQuantity > 0);
        //   labelsRequest.products.push(product);
        //   this.productsCount = this.labelsRequest.products.length;
        //   labelsRequest.branch = this.labelsRequest.branch;
        //   this.printLabels(this.webTrackUser.bisTrackUserId, labelsRequest, (responseResult) => {
        //     if (responseResult) { }
        //   });
        // }
      }
    }

  }

  createLabelRequestWithProduct(product) {
    this.labelsRequest = new LabelsRequest();
    this.labelsRequest.products = [];
    product.dateTimeLastModified = new Date();
    product.dateTimeCreated = new Date();
    this.labelsRequest.products.push(product);
    this.productsCount = this.labelsRequest.products.length;
    this.labelsRequest.printingMode = LabelsRequestPrintingMode.OnDemand;
  }

  clearLabelsData(frompage: string = PageNames.ProductSearch) {
    this.labelRequestFormFlag = false;
    this.wizardStep = 0;
    this.fromDashboard = false;
    this.labelsRequest = null;
    this.isMoreProducts = false;
    this.productsCount = 0;
    this.successMessage = '';
    this.fromPageToLabels = frompage;
  }

  // clearSubmitClikLabelsData() {
  // this.labelRequestFormFlag = false;
  // this.wizardStep = 0;
  // this.fromDashboard = false;
  // this.labelsRequest = new LabelsRequest();
  // this.labelsRequest.templates = [];
  // this.isMoreProducts = false;
  // this.productsCount = 0;
  // }
}
